const resources = JSON.parse(document.getElementById('css-non-critical-resources').textContent);
const delay = 5000;
const eventList = ["keydown", "mousemove", "wheel", "touchmove", "touchstart", "touchend"];

function loadResource(url) {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = url;
  document.head.appendChild(link);
}

let delayResourcesLoaded = false;
function loadDelayResources() {
  if (!delayResourcesLoaded) {
    resources.delay.forEach(loadResource);
    delayResourcesLoaded = true;
  }
}

function loadDeferResources() {
  resources.defer.forEach(loadResource);
}

function triggerScripts() {
  loadDelayResources();
  clearTimeout(autoLoadTimeout);
  eventList.forEach(function (event) {
    window.removeEventListener(event, triggerScripts, { passive: true });
  });
}

eventList.forEach(function (event) {
  window.addEventListener(event, triggerScripts, { passive: true });
});

const autoLoadTimeout = setTimeout(loadDelayResources, delay);


loadDeferResources();
